module.exports = __webpack_public_path__ + "static/media/147.047c4741.wav";